import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {

  transform(value: string): any {
    if (!value) {
      return '';
    }

    const splits = value.split(':');
    let isAm = +splits[0] < 12;;

    return (+splits[0] > 12 ? +splits[0] - 12 : +splits[0]) + ':' + splits[1] + ' ' + (isAm ? 'AM' : 'PM');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/time.pipe.ts